import React, { Component } from 'react';
import { Field } from 'redux-form';
import SelectField from './SelectField';

class CustomIncomeDateSelect extends Component {

    constructor(props) {
        super(props);
        this.state = { paymentDates: [] };
    }

    componentWillMount() {
        this.state.paymentDates = [
            {
              "id": 2,
              "name": "Del 1 al 5 de cada mes"
            },
            {
              "id": 7,
              "name": "Del 6 al 10 de cada mes"
            },
            {
              "id": 22,
              "name": "Del 11 al 31 de cada mes"
            }
        ];
    }

    render() {
        return (
            <Field
                className="form-control"
                name={this.props.name}
                component={SelectField}
                options={this.state.paymentDates}
                defaultValue={'Fecha Cobro'}
                type={this.props.type}
            />
        );
    }
}

export default CustomIncomeDateSelect;


/** WEBPACK FOOTER **
 ** ./src/components/CustomIncomeDateSelect.js
 **/